<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">제품코드관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>제품코드</p>
                <input type="text" placeholder="제품코드를 입력하세요" class="form_control" v-model="searchInfo.productCd" @keyup.enter="fn_search" @change="fn_search_change">
              </li>
              <li>
                <p>약재명</p>
                <input type="text" placeholder="약재명을 입력하세요" class="form_control" v-model="searchInfo.medicineNm" @keyup.enter="fn_search" @change="fn_search_change">
              </li>
              <li>
                <p>제약회사명</p>
                <input type="text" placeholder="제약회사명을 입력하세요" class="form_control" v-model="searchInfo.companyNm" @keyup.enter="fn_search" @change="fn_search_change">
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
              <div class="form_select"></div>
              <div class="form_inline">
                <input type="file" ref="productCodeExcelUpload" @change="fn_excel_read" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" hidden/>
              <button class="btn btn_md btn_outline" @click="fn_excel_upload_click"><i class="icon icon_excel"></i>Excel 업로드</button>
              <button class="btn btn_md btn_darkblue" @click="fn_move_reg_page">신규 등록</button>
              </div>
            </div>
            <table class="list">
              <colgroup>
                <col width="300">
              </colgroup>
              <thead>                  
                <tr>
                    <th>제품코드</th>
                    <th>약재명</th>
                    <th>이명</th>
                    <th>제약회사명</th>
                    <th>처리</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="productCodeList.length == 0">
                    <td colspan="5"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in productCodeList" :key="index">
                  <td><span>{{ item.product_code }}</span></td>
                  <td><span>{{ item.med_hrb_nm }}</span></td>
                  <td><span>{{ item.med_alias }}</span></td>
                  <td><span>{{ item.pharmaceutical_company_nm }}</span></td>
                  <td>
                    <div class="form_inline">
                      <button class="icon icon_del" @click="fn_delete_product_code(item.product_code_uuid)"></button>
                      <button class="icon icon_edit" @click="fn_move_dtl_page(item.product_code_uuid)"></button>                                     
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="moveGrpPage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import Datepicker from '@/components/Datepicker.vue'
    import { read, utils } from 'xlsx'

export default {
    name: 'MedicineWrhsMngt',
    components: {
      Pagination,
      Datepicker,
    },
    data() {
      return {
        searchInfo : {
            productCd : '',
            medicineNm : '',
            companyNm : '',
            pageInfo : {
              page : 1,
              pageSize : 10,
              totPage : 0
            } 
        },
        searchInfoChange : false,
        pagingShow : false,
        productCodeList: [],
        selected: null
      }
    },
    async created(){
      //검색정보 처리
      let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];             
      if(searchInfoStore != null && searchInfoStore != {}){
          this.searchInfo = searchInfoStore
      }
    },
    mounted(){          
        this.fn_search();
    },
    methods : {
        fn_move_reg_page(){
            this.$router.push("/admin/medicine/productCodeMngtReg");
        },
        fn_search_change(){
            //검색 정보 변경 여부
            let searchInfoStore = this.$store.getters['commonStore/getSearchInfo'];

            console.log("@@@@ searchInfoStore : %o ",searchInfoStore)


            if(searchInfoStore != null && searchInfoStore != {}){
                console.log("1111")
                if(this.searchInfo.productCd != searchInfoStore.productCd){
                  console.log("2222")
                  this.searchInfoChange = true;
                }
                console.log(this.searchInfo.medicineNm  + " @@@@ " + searchInfoStore.medicineNm)
                if(this.searchInfo.medicineNm != searchInfoStore.medicineNm){
                  console.log("3333")
                  this.searchInfoChange = true;
                }
                if(this.searchInfo.companyNm != searchInfoStore.companyNm){
                  console.log("1144411")
                  this.searchInfoChange = true;
                }
            }
          },
        fn_search(){
             console.log("5555")
            // 검색정보 변경 체크
            if(this.searchInfoChange){
              //검색 조건 변경이 있을 시 페이지 정보 초기화
              this.searchInfo.pageInfo.page = 1;
            }

            axios
                .post("/api/medicine/getProductCodeList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.productCodeList = res.data.productCodeList;

                    console.log("@@@@ productCodeList : %o",this.productCodeList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;
                
                    if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;                          
                    }
                    
                    // 검색 정보 저장
                    this.$store.dispatch('commonStore/setSearchInfo', this.searchInfo);
                    this.searchInfoChange = false;
                })
                .catch((err) => console.log(err));
            
        },
        moveGrpPage(page){
            this.searchInfo.pageInfo.page = page;
            this.fn_search();
        },
        fn_move_dtl_page(productCodeUuid){
            console.log("@@@@ productCodeUuid : "+productCodeUuid);
            this.$store.dispatch('medicine/setProductCodeUuid', productCodeUuid);
            this.$store.dispatch('medicine/setStatus', 'M');  
            this.$router.push({ name : 'productCodeMngtReg'});
        },
        fn_delete_product_code(productCodeUuid){

          let param = new Object();
          param.productCodeUuid = productCodeUuid;

          axios
                .post("/api/medicine/deleteProductCodeInfo", param)
                .then((res) => {
                    alert("제품코드가 삭제되었습니다.");
                    this.fn_search();
                })
                .catch((err) => console.log(err));
        },
        fn_excel_upload_click(){
          let fileInputElement = this.$refs.productCodeExcelUpload;
          fileInputElement.click();
      },
        fn_excel_read(event){
        console.log("@@@@@ fn_excel_read ");

        const file = event.target.files[0];
        let reader = new FileReader();
        
        reader.onload = (e) => {
            
            let data = reader.result;
            

            //type 종류: 'base64' | 'binary' | 'buffer' | 'file' | 'array' | 'string';
            const workbook = read(data, {type: 'binary'});

            workbook.SheetNames.forEach(sheetName  => {
              console.log("@@@@@ sheetName : %o",sheetName);

              if(sheetName == "한약재 제품코드"){        
                
                  workbook.Sheets[sheetName].A1.w = "dedicine_nm";
                  workbook.Sheets[sheetName].B1.w = "company_nm";
                  workbook.Sheets[sheetName].C1.w = "product_cd";
                  
                  const roa = utils.sheet_to_json(workbook.Sheets[sheetName]);                       
                  
                  this.fn_excel_productCode_upload(roa);         

              }
            });

            
                            
        };
        
        reader.readAsBinaryString(file);
        
      },
      fn_excel_productCode_upload(uploadData){
        console.log("@@@@@ fn_excel_med_upload : %o",uploadData);

        axios
          .post("/api/medicine/excelProductCodeUpload", uploadData)
          .then((res) => {
              // alert("삭제되었습니다");
              // this.fn_dtl_search(medHrbCd);              
          })
          .catch((err) => console.log(err));


          this.$refs.productCodeExcelUpload.values = {};

      },
    }   
  }
</script>